export enum InteractionLabels {
    Chat = "Chat",
    EmailIn = "Email In",
    EmailOut = "Email Out",
    CallIn = "Call In",
    CallInternal = "Call Internal",
    CallOut = "Call Out",
}
